import { EncartPackProduitsTitreTexteLogos } from '@components/encart-pack-produits-titre-texte-logos/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const encartPackProduitsTitreTexteLogosMock = (withText = false): Block<EncartPackProduitsTitreTexteLogos> => ({
  type: 'encart-pack-produits-titre-texte-logos',
  data: {
    title: {
      text: `Les meilleures marques [[à prix SoCoo'c]]`,
      as: 'span',
    },
    pictos: withText ? undefined : Array(11).fill(imageMock),
    text: withText
      ? `Un espace repas 100% vous ? Rien de plus simple ! <br/>Choissez parmi nos piétements et nos finitions de plans ...`
      : undefined,
  },
});
